import styled from 'styled-components';
import {dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';

export const body = styled.div`
    flex: 1;
    width: 100%;
    ${dFlexColumnCenter}
    gap: var(--space-xl);
    padding: var(--space-md) 0;
`;

export const title = styled.h3`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    text-align: center;
    word-break: break-word;
`;

export const ticketNo = styled.div`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    text-align: center;
`;